import React, {useContext,useEffect,useState,useRef} from "react"
import Register from "./dialogs/Register"
import Logout from "./dialogs/Logout"
import SignUp from "./dialogs/SignUp"
import { ToastContainer } from 'react-toastify';

export const DialogContext = React.createContext(null)

export const useDialog = () => {
  const context = useContext(DialogContext)
  if (!context) throw new Error("useDialog is outside of Dialog Context !")
  return context
}

const DialogProvider = props => {

  const [activeDialog, setActiveDialog] = useState('')
  const [query,setQuery] = useState({})
  const registerRef = useRef(null),
        logoutRef = useRef(null),
        signupRef = useRef(null)

  useEffect( () => {
    //console.log('active dialog is:',activeDialog)
    switch (activeDialog){
      case 'register': 
        registerRef.current.openDialog()
        break
      case 'logout':
        logoutRef.current.openDialog()
        break
      case 'sign up':
        signupRef.current.openDialog(query)
        break
    default:
      break;
    }

  },[activeDialog])

  function openDialog( dialog, queryData = {} ){
    setActiveDialog(dialog)
    setQuery(queryData)
    console.log("dialog provider got",dialog,queryData)
  }

  return <DialogContext.Provider value={openDialog} {...props}>
    {props.children}
    <Register ref={registerRef} />
    <Logout ref={logoutRef} />
    <SignUp ref={signupRef} props={query} />
    <ToastContainer enableMultiContainer containerId={'app'}/>
  </DialogContext.Provider>
}
export default DialogProvider